// extracted by mini-css-extract-plugin
export default {"root":"Collapsable_root__fwoZv","container":"Collapsable_container__2TmHd","opened":"Collapsable_opened__gcCc6"};